import { __makeTemplateObject } from "tslib";
import styled from 'styled-components';
import { compose, space, layout, color } from 'styled-system';
var Svg = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  flex: none;\n"], ["\n  ", ";\n  flex: none;\n"])), compose(space, layout, color));
Svg.defaultProps = {
  as: 'svg'
};
export default Svg;
var templateObject_1;